import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { Search, Users, Target, FileSpreadsheet } from "lucide-react";

export default function EmployersLanding() {
  const feats = [
    { icon: Search, t: "Advanced Talent Search", d: "Filter by experience, products, processes, education & 20+ industry parameters." },
    { icon: Target, t: "Smart Match Scoring", d: "Every candidate ranked against your requirement with explainable match reasons." },
    { icon: Users, t: "Manage Applications", d: "Track candidates from Applied to Hired with a clean pipeline view." },
    { icon: FileSpreadsheet, t: "Bulk Export & Requirements", d: "Create hiring requirements and export shortlists to CSV instantly." },
  ];
  return (
    <PublicLayout>
      <section className="bg-slate-900 text-white hero-grid">
        <div className="max-w-5xl mx-auto px-6 py-20 text-center">
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold">Hire specialized cable & conductor talent</h1>
          <p className="mt-4 text-slate-300 max-w-2xl mx-auto">Post jobs and search a database built exclusively for cable, wire, conductor and power transmission manufacturing.</p>
          <Link to="/login?role=employer" data-testid="employer-register-btn" className="inline-block mt-8 copper-gradient font-semibold px-8 py-3.5 rounded-lg hover:opacity-95 transition-opacity">Post a Job</Link>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-6">
        {feats.map((f) => (
          <div key={f.t} className="bg-white p-7 rounded-xl border border-slate-200 flex gap-4">
            <div className="w-11 h-11 rounded-lg copper-gradient flex items-center justify-center shrink-0"><f.icon className="w-5 h-5 text-white" /></div>
            <div>
              <h3 className="font-display font-semibold text-lg text-slate-900">{f.t}</h3>
              <p className="text-sm text-slate-500 mt-1">{f.d}</p>
            </div>
          </div>
        ))}
      </section>
    </PublicLayout>
  );
}
